import type {DateRangeType, TimeUnit} from 'common/widgets/date-range-picker/models/types';
import type {NotificationType} from 'common/types/reports/messages';
import {ValidPropertyValue} from 'common/util/format-property';
import {EventPropertyToggleChoices} from 'common/widgets/profile-activity/activity-properties/types';
import type {UserDemographicsTab} from 'common/report/util/profile/types';

export enum TrackedEvents {
  // Activity Stream Tracking
  QueryFinished = `[User Profile] Profile Query Finished`,
  ShowMoreEvents = `[User Profile] Show More Events`,
  SeeUserInInsights = `[User Profile] See User in Insights`,
  UserEventExpanded = `[User Profile] User Event Expanded`,

  // User Demographic Tracking
  SearchUserProperties = `[User Profile] Search User Properties`,

  CreateProperty = `[User Profile] Create New User Property`,
  UpdateProperty = `[User Profile] Update User Property`,
  DeleteUserProperty = `[User Profile] Delete User Property`,
  DeleteProfile = `[User Profile] Delete Profile`,

  SeePropertyChangeLog = `[User Profile] See Property Changelog`,
  ViewCompanyProfileSummary = `[Company Profile] view company profile summary`,
  ClickCompanyProfileReport = `[Company Profile] click report`,
  ClickCompanyProfileUserList = `[Company Profile] click user list`,
  ClickCompanyProfileUser = `[Company Profile] click user`,
  ViewCompanyProfileActivityFeed = `[Company Profile] view activity feed`,
  ViewCompanyProfileUsersTab = `[Company Profile] view users tab`,
}

export interface TrackedProperties {
  // Required in all profile tracking, but populated by `appPersistentProperties` in tracker initialization
  'Profile Distinct Id'?: string;

  // rest are optional depending on event
  '# of Included Events'?: number;
  '# of Excluded Events'?: number;
  '# of Messages'?: number;
  '# of Properties'?: number;
  Datetime?: string;
  'Date range from'?: string;
  'Date range to'?: string;
  'Date range type'?: DateRangeType;
  'Date range unit'?: TimeUnit;
  'Date range value'?: number;
  Email?: string;
  'Event Name'?: string;
  Grouped?: boolean;
  'Message Type'?: NotificationType.Push | NotificationType.Email;
  'New tab'?: UserDemographicsTab;
  'Preset Date range'?: boolean;
  'Profile Email'?: string;
  'Property Name'?: string | number;
  'Property Value'?: ValidPropertyValue;
  'Properties Tab'?: EventPropertyToggleChoices;
  'Old Property Value'?: ValidPropertyValue;
  'Search query'?: string;
  'Selectively Showing Events'?: boolean;
  'Toggle type'?: string;
  'Sidebar mode'?: boolean;
}
